import React from 'react'
import styles from './footer.module.css'


export default function Frontpage(props) {
    return (

        <div className={styles.footerContainer}>
            <div className={styles.footerText}><p> Background image from <a href="https://pixabay.com/nl/photos/salade-eten-italiaans-smaakvol-2068220/">Pixabay</a> - Title icon from <a href="https://icons8.com/icons/set/basil"> icons8.com</a> - Made with React JS</p></div>

        </div>
        //https://www.pexels.com/photo/ingredients-on-table-for-cooking-6507004/
        //    https://www.pexels.com/photo/green-plant-in-white-ceramic-vase-3756659/
        // https://www.pexels.com/photo/potted-plant-on-a-kitchen-shelf-8581368/
        //
    )
}